import type { EsMrpwProductVersionFormat } from './model.ts'

export const allEsMrpwProductVersions = [
  'product-es-mrp-wakam-1.0.0-2026-01-13',
  'product-es-mrp-wakam-1.0.1-2026-02-18',
  'product-es-mrp-wakam-1.1.0-2026-08-03',
] as const satisfies EsMrpwProductVersionFormat[]

export type EsMrpwProductVersion = (typeof allEsMrpwProductVersions)[number]
